import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Auth from './Auth/Auth.js';
import Home from './Pages/home.js';
import Register from './Pages/register.js';
import Rules from './Pages/rules.js';
import Nutrition from './Pages/nutrition.js';
import FAQ from './Pages/faq.js';
import Admin from './Pages/admin.js';

import SignOut from './Pages/signOut.js';

import ComingSoon from './Pages/comingSoon.js';

// import Confetti from './Pages/confetti.js';

function routeFile() {
    return (
        <Router>
            <Routes>
                <Route path="/coming-soon" element={<ComingSoon />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/" element={<Home />} />
                <Route path="/register" element={<Register />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/nutrition" element={<Nutrition />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/sign-out" element={<SignOut />} />
                {/* <Route path='/confetti' element={<Confetti />} /> */}
            </Routes>
        </Router>
    );
}

export default routeFile;
